(() => {
  if (window.__obpCartV2Initialized) return;
  window.__obpCartV2Initialized = true;

  const getCartDrawer = () => document.getElementById('Cart-Drawer');
  const obpProductHandles = new Set([
    'onebuttonphone-model-2024',
    'one-button-phone-model-2024-inkl-ladestation',
    'one-button-phone-modell-2024-ladestation-displayschutzfolie',
    'one-button-phone-modell-2024-mit-original-displayschutzfolie'
  ]);
  let stationRuleRepairPromise = null;
  let stationRuleRepairTimer = null;
  let cartCountSyncTimer = null;

  const syncHeaderCartCount = (cart) => {
    if (!cart || !Number.isFinite(Number(cart.item_count))) return;
    const itemCount = Number(cart.item_count);
    const itemLabel = itemCount === 1 ? 'Artikel' : 'Artikel';

    document.querySelectorAll('.obp-site-header__cart-count').forEach((count) => {
      count.textContent = itemCount > 99 ? '99+' : String(itemCount);
    });
    document.querySelectorAll('a[href$="/cart"][aria-label^="Warenkorb mit"]').forEach((link) => {
      link.setAttribute('aria-label', `Warenkorb mit ${itemCount} ${itemLabel}`);
    });
  };

  const refreshDrawerSections = (drawer, cart, quantity = null) => {
    const sections = drawer?.getSectionsToRender?.() || [];
    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element || !cart.sections?.[section.section]) return;
      const elementToReplace = element.querySelector(section.selector) || element;
      elementToReplace.innerHTML = drawer.getSectionInnerHTML(
        cart.sections[section.section],
        section.selector
      );
    });

    document.dispatchEvent(new CustomEvent('line-item:change:end', {
      detail: { quantity, cart }
    }));
  };

  const fetchCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht geprüft werden.');
    return response.json();
  };

  const scheduleHeaderCartCountSync = (cart = null) => {
    window.clearTimeout(cartCountSyncTimer);
    if (cart?.item_count != null) {
      syncHeaderCartCount(cart);
      return;
    }

    cartCountSyncTimer = window.setTimeout(async () => {
      try {
        syncHeaderCartCount(await fetchCart());
      } catch (error) {
        console.error('[One Button Phone] Warenkorb-Zähler:', error);
      }
    }, 60);
  };

  const repairStandaloneStationRule = async (providedCart = null) => {
    if (stationRuleRepairPromise) return stationRuleRepairPromise;

    const drawer = getCartDrawer();
    const regularHandle = drawer?.dataset.obpRegularStationHandle;
    const extraHandle = drawer?.dataset.obpExtraStationHandle;
    const regularVariantId = Number(drawer?.dataset.obpRegularStationVariantId);
    if (!drawer || !regularHandle || !extraHandle || !regularVariantId) return false;

    stationRuleRepairPromise = (async () => {
      const cart = providedCart?.items ? providedCart : await fetchCart();
      const extraLine = cart.items.find((item) => item.handle === extraHandle);
      if (!extraLine) return false;

      const hasRegularStation = cart.items.some((item) => item.handle === regularHandle);
      const hasQualifyingObpProduct = cart.items.some((item) => obpProductHandles.has(item.handle));
      if (hasRegularStation || hasQualifyingObpProduct) return false;

      const sections = drawer.getSectionsToRender?.() || [];
      const updates = {
        [regularVariantId]: 1,
        [extraLine.key]: Math.max(0, extraLine.quantity - 1)
      };
      const response = await fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname
        })
      });
      const repairedCart = await response.json();
      if (!response.ok || repairedCart.status) {
        throw new Error(repairedCart.description || 'Die Ladestationspreise konnten nicht aktualisiert werden.');
      }

      refreshDrawerSections(drawer, repairedCart);
      window.setTimeout(() => getCartDrawer()?.open(), 80);
      return true;
    })()
      .catch((error) => {
        console.error('[One Button Phone] Ladestationsregel:', error);
        return false;
      })
      .finally(() => {
        stationRuleRepairPromise = null;
      });

    return stationRuleRepairPromise;
  };

  const scheduleStationRuleRepair = (cart = null) => {
    window.clearTimeout(stationRuleRepairTimer);
    stationRuleRepairTimer = window.setTimeout(() => {
      repairStandaloneStationRule(cart);
    }, 80);
  };

  document.addEventListener('line-item:change:end', (event) => {
    scheduleHeaderCartCountSync(event.detail?.cart || null);
    scheduleStationRuleRepair(event.detail?.cart || null);
  });
  document.addEventListener('cart:refresh', () => {
    scheduleHeaderCartCountSync();
    scheduleStationRuleRepair();
  });
  document.addEventListener('cart:item-added', () => {
    scheduleHeaderCartCountSync();
    scheduleStationRuleRepair();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleHeaderCartCountSync();
      scheduleStationRuleRepair();
    }, { once: true });
  } else {
    scheduleHeaderCartCountSync();
    scheduleStationRuleRepair();
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('cart-remove, quantity-selector .minus, quantity-selector .plus')) return;
    window.setTimeout(() => scheduleHeaderCartCountSync(), 450);
  });

  document.addEventListener('click', async (event) => {
    const noteButton = event.target.closest('[data-obp-save-note]');
    if (noteButton && !noteButton.disabled) {
      event.preventDefault();
      const drawer = noteButton.closest('cart-drawer');
      const note = drawer?.querySelector('#mini-cart__notes')?.value || '';
      noteButton.disabled = true;

      try {
        const response = await fetch(`${theme.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ note })
        });
        if (!response.ok) throw new Error('Der Bestellhinweis konnte nicht gespeichert werden.');
        const label = noteButton.querySelector('span');
        if (label) label.textContent = 'Gespeichert';
      } catch (error) {
        const label = noteButton.querySelector('span');
        if (label) label.textContent = 'Bitte erneut versuchen';
      } finally {
        window.setTimeout(() => {
          noteButton.disabled = false;
          const label = noteButton.querySelector('span');
          if (label) label.textContent = 'Speichern';
        }, 1400);
      }
      return;
    }

    const familyButton = event.target.closest('[data-obp-buddy-family-target]');
    if (familyButton && !familyButton.disabled && !familyButton.classList.contains('loading')) {
      event.preventDefault();
      const drawer = familyButton.closest('cart-drawer');
      const errorMessage = drawer?.querySelector('.obp-cart__buddy-family-error');
      const line = Number(familyButton.dataset.lineIndex);
      const quantity = Number(familyButton.dataset.targetQuantity);
      if (!drawer || !line || !quantity) return;

      familyButton.classList.add('loading');
      familyButton.disabled = true;
      familyButton.setAttribute('aria-busy', 'true');
      if (errorMessage) errorMessage.hidden = true;

      try {
        const sections = drawer.getSectionsToRender();
        const response = await fetch(theme.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            line,
            quantity,
            sections: sections.map((section) => section.section),
            sections_url: window.location.pathname
          })
        });
        const cart = await response.json();
        if (!response.ok || cart.status) {
          throw new Error(cart.description || 'Die Menge konnte nicht angepasst werden.');
        }

        refreshDrawerSections(drawer, cart, quantity);
        window.setTimeout(() => getCartDrawer()?.open(), 80);
      } catch (error) {
        familyButton.disabled = false;
        if (errorMessage) {
          errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
          errorMessage.hidden = false;
        }
      } finally {
        familyButton.classList.remove('loading');
        familyButton.removeAttribute('aria-busy');
      }
      return;
    }

    const button = event.target.closest('.obp-cart__addon-button[data-variant-id]');
    if (!button || button.disabled || button.classList.contains('loading')) return;

    event.preventDefault();
    const drawer = button.closest('cart-drawer');
    const errorMessage = drawer?.querySelector('.obp-cart__addon-error');
    button.classList.add('loading');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (errorMessage) errorMessage.hidden = true;

    try {
      const response = await fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
        })
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || 'Das Produkt konnte nicht hinzugefügt werden.');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { product: result.items?.[0] || result }
      }));
      window.setTimeout(() => getCartDrawer()?.open(), 100);
    } catch (error) {
      button.disabled = false;
      if (errorMessage) {
        errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
        errorMessage.hidden = false;
      }
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
    }
  });
})();
